import { animMerge, scale, slideVertical } from '@/utils/animations/commom';
import { motion } from 'motion/react';
import { twMerge } from 'tailwind-merge';

const badgeColors = {
  info: 'bg-success',
  success: 'bg-success',
  warning: 'bg-warning',
  error: 'bg-error',
};
interface BadgeProps {
  count?: number | string;
  className?: string;
  classNameContainer?: string;
  testId?: string;
  color?: keyof typeof badgeColors;
  children?: JSX.Element;
  position?: string;
}
export default function Badge(props: BadgeProps) {
  const {
    count,
    className,
    classNameContainer,
    testId,
    children,
    position,
    color,
  } = props;
  return (
    <div className={twMerge('relative text-base-content', classNameContainer)}>
      {children}
      <motion.div
        data-testid={testId}
        {...animMerge(slideVertical(10), scale)}
        transition={{ duration: 0.1 }}
        className={twMerge(
          'rounded-full absolute leading-none px-1 border-base-100 py-0.5 !text-10 text-base-100',
          badgeColors[color || 'error'],
          position || 'right-0 bottom-0',
          count ? '' : 'hidden',
          className,
        )}
      >
        {count}
      </motion.div>
    </div>
  );
}
